// Home's default order, Recent (Josh 10-01: "it should be the most recently used sessions … by default"): the rows
// whose session has a window open on this device come first, the one used last on top; then every other row by its
// last activity, newest first. "Used" is this device's: when a session window last came to the front here
// (`cody:front`, kept in localStorage); a row open here but never brought forward falls back to its activity time.
// Needs you and Cost keep their own orders (home.js).
//
// One seam: `orderRecent(items, openHere)` — `items` Home's rows ({id, time, row?: {session}}), `openHere` the
// session ids with a window open on this device; `lastUsed()` the times; `noteUsed(id)` (the front event does it).

const KEY = 'home.lastUsed.v1'
const KEEP = 400   // the newest this many are kept

let used = null
export function lastUsed() {
  if (used) return used
  try { used = JSON.parse(localStorage.getItem(KEY) || '{}') || {} } catch { used = {} }
  return used
}
export function noteUsed(sessionID, at = Date.now()) {
  if (!sessionID) return
  const all = lastUsed()
  all[sessionID] = at
  const ids = Object.keys(all)
  if (ids.length > KEEP) for (const id of ids.sort((a, b) => all[a] - all[b]).slice(0, ids.length - KEEP)) delete all[id]
  try { localStorage.setItem(KEY, JSON.stringify(all)) } catch {}
}
globalThis.addEventListener?.('cody:front', (e) => { if (e.detail?.sessionID) noteUsed(e.detail.sessionID) })

/// The session a row stands for: an opencode session's own id, an extension row's Cody session.
export const sessionOfRow = (it) => it.row ? it.row.session || null : it.id

/// Open here first (used last on top), then the rest by activity; ties keep their order.
export function orderRecent(items, openHere = new Set(), times = lastUsed()) {
  const open = (it) => { const s = sessionOfRow(it); return !!s && openHere.has(s) }
  const usedAt = (it) => times[sessionOfRow(it)] || it.time || 0
  return items.map((it, i) => ({ it, i, open: open(it) })).sort((a, b) =>
    (b.open - a.open) || (a.open ? usedAt(b.it) - usedAt(a.it) : (b.it.time || 0) - (a.it.time || 0)) || a.i - b.i).map((x) => x.it)
}
